import * as React from 'react';
import S from './Form.styles';
const ErrorSummary = (props) => {
    return (React.createElement(S.ErrorList, { variants: {
            hidden: {
                opacity: 0,
                y: 20,
            },
            visible: {
                opacity: 1,
                y: 0,
            },
        }, initial: "hidden", animate: "visible", exit: "hidden" }, props.errors.map((error) => (React.createElement(S.ErrorListItem, { key: error, dangerouslySetInnerHTML: { __html: `<span>!</span> <div>${error}</div>` } })))));
};
export default ErrorSummary;
